"use client";

import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export default function WhatOurClientsSay() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const testimonials = [{
    author: "John D.",
    quote: "Romero Welding provided exceptional service and top-notch craftsmanship for our commercial project.",
    position: "Project Manager"
  }, {
    author: "Maria S.",
    quote: "Highly recommend Romero Welding for their professionalism and attention to detail.",
    position: "Business Owner"
  }];
  return <section ref={sectionRef} className="bg-muted py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-center text-foreground mb-4">
          What Our Clients Say
        </h2>
        <p className="text-center text-foreground/70 mb-12 max-w-2xl mx-auto">Don't just take our word for it. Hear from the clients who trust Romero Welding Inc. for their industrial and commercial welding needs. These are just examples for now since this website is new and hasn't received any real testimonials yet.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {testimonials.map((testimonial, i) => <Card key={i} data-index={i} className={`card transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${sectionVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
        }}>
              <CardHeader>
                <div className="flex items-start gap-3">
                  <div className="rounded-full bg-accent/10 p-3 shrink-0">
                    <Quote className="w-5 h-5 text-accent" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <CardTitle className="text-lg md:text-xl text-foreground">
                      {testimonial.author}
                    </CardTitle>
                    <CardDescription className="text-sm text-foreground/60">
                      {testimonial.position}
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-foreground/80 leading-relaxed">
                  "{testimonial.quote}"
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}